// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const RefreshIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="RefreshIcon" ref={forwardedRef} {...props}>
      <path d="M16.5 8.25h-5v-1.5h2.458a5 5 0 0 0-3.452-1.379 5.003 5.003 0 0 0-5.006 5c0 2.76 2.24 5 5.006 5a5 5 0 0 0 3.526-1.45l1.062 1.06a6.5 6.5 0 0 1-4.588 1.89A6.503 6.503 0 0 1 4 10.371c0-3.59 2.913-6.5 6.506-6.5A6.5 6.5 0 0 1 15 5.671V3.25h1.5z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const RefreshIcon = /* @__PURE__ */ Object.assign(RefreshIconComponent, {
  displayName: 'RefreshIcon',
});
